import { State } from 'xstate';

import { paymentProfiles } from './paymentProfiles';

type PaymentProfilesMachine = typeof paymentProfiles;

type PaymentProfilesState = State<PaymentProfilesMachine['context']>;

export const getPaymentProfiles = (machineState: PaymentProfilesState) => {
  return machineState.context.paymentProfiles;
};
export const getPaymentProfilesById =
  (paymentProfileId: number) => (machineState: PaymentProfilesState) => {
    return machineState.context.paymentProfiles.find(
      (paymentProfile) => paymentProfile.id === paymentProfileId
    );
  };

export const getPaymentProfilesState = (
  machineState: PaymentProfilesState
) => ({
  isLoading: machineState.matches('fetchingProfiles'),
  isError: machineState.matches('error'),
});

export const paymentProfilesSelectors = {
  getPaymentProfilesState,
  getPaymentProfilesById,
  getPaymentProfiles,
};
